import { http, type HttpError } from "../../http";
import type { Result } from "../../types/result";

export type SubmitPulseInput = {
  touchpoint: string;
  ref_id?: string;
  reaction: string;
  comment?: string;
};

function buildPulseBody(input: SubmitPulseInput): URLSearchParams {
  const body = new URLSearchParams();
  body.set("touchpoint", String(input.touchpoint || "").trim());
  body.set("ref_id", String(input.ref_id || "").trim());
  body.set("reaction", String(input.reaction || "").trim());
  body.set("comment", String(input.comment || "").trim());
  return body;
}

export async function submitPulse(input: SubmitPulseInput): Promise<Result<void, HttpError>> {
  const result = await http.post<unknown>("/participant/pulse", buildPulseBody(input), {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  if (!result.ok) {
    return result;
  }
  return { ok: true, value: undefined };
}
